import { useSelector } from "react-redux";
import { getFlight } from "../store/flightDetails/selectors";
import { getSearch } from "../store/search/selectors";
import { INFANT_MAX_AGE } from "@flights/constants";
import { isInfant } from "../store/selectors/passengers";

export const useHasInfantTraveller = () => {
  const search = useSelector(getSearch);
  const flight = useSelector(getFlight);

  return Boolean(search.children.some((age) => age <= INFANT_MAX_AGE) || flight?.travellers?.some((t) => isInfant(t)));
};
